import React, { useState } from 'react'

type ProgressiveImageProps = {
  src: string
  placeholder: string
  alt?: string
  className?: string
  style?: React.CSSProperties
}

const ProgressiveImage: React.FC<ProgressiveImageProps> = ({
  src,
  placeholder,
  alt,
  className,
  style,
}) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div style={{ position: 'relative', ...style }} className={className}>
      <img
        src={placeholder}
        alt={alt}
        style={{
          filter: 'blur(10px)',
          transition: 'opacity 0.3s',
          opacity: loaded ? 0 : 1,
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <img
        src={src}
        alt={alt}
        style={{
          transition: 'opacity 0.3s',
          opacity: loaded ? 1 : 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  )
}

export default ProgressiveImage
